<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-02-29 14:11:50
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-13 10:18:32
 * @FilePath: /chaoyongtuan/src/views/contentLibray/LocalMaterial/list/components/list.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<div class="flex-row-align-center flex-just-between">
			<div class="flex-row-align-center">
				<!-- <div class="mr-12 listHeader ml-12">
						<el-checkbox v-model="checkAll" @change="selectAll" :indeterminate="indeterminate">
							<span class="font-h6-regular color-gy-9">本页全选</span>
						</el-checkbox>
					</div> -->
				<el-button v-if="$auth.hasPermi('upload:local-material')" @click="handleUpload" type="primary">上传文件</el-button>
				<el-tooltip v-if="$auth.hasPermi('addTag:local-material')" :disabled="!!selectionList.length" content="请先选择素材" placement="top">
					<el-button @click="handleAddTag">批量打标</el-button>
				</el-tooltip>
				<el-tooltip v-if="$auth.hasPermi('delete:local-material')" :disabled="!!selectionList.length" content="请先选择素材" placement="top">
					<el-button @click="handleDel()">批量删除</el-button>
				</el-tooltip>
			</div>
			<div
				v-if="$auth.hasPermi('setUp:local-material')"
				class="yx-color-text-regular font-h6-regular mr-12 cursor-pointer hover"
				@click="openSettings"
			>
				<i class="el-icon-setting fz-14"></i>
				<span class="ml-6">设置</span>
			</div>
		</div>
		<multi-table
			:key="refreshKey"
			v-loading="loading"
			:page="pageInfo"
			class="multiTable"
			ref="table"
			:default-sort="{ prop: 'addTime', order: 'descending' }"
			:selectionChange="handleSelectionChange"
			:columns="columns"
			@getSortList="sortChange"
			@gePartnerList="gePartnerList"
			:list="tableData"
			:options="options"
			:total="total"
			:cellMouseEnter="cellMouseEnter"
			:cellMouseLeave="cellMouseLeave"
		>
			<template slot="empty">
				<empty></empty>
			</template>
		</multi-table>
		<!--视频播放器-->
		<videoPlayer controlsList="nodownload" ref="videoPlayer" controls muted videoWidth="800" videoHeight="600" />
		<!--设置弹窗-->
		<rule-settings ref="ruleSettings" />
		<!--上传图片/视频-->
		<UploadBigFileDialog :type="isVideoMaterial ? 'video' : 'picture'" ref="uploadVideo" @close="refresh"></UploadBigFileDialog>
		<!--标签更改dialog-->
		<TagDialog showAddTag ref="tagDialog" type="2" @refreshList="getList()"></TagDialog>
	</div>
</template>
<script>
import ruleSettings from './ruleSettings/ruleSetting.vue';
import { materialLibraryList, batchDownload, batchDeleteMaterial } from '@/api/contentLibray.js';
import debounce from 'lodash/debounce';
import getColumns from './columns';
import TagDialog from '@/components/business/tagDialog';
import UploadBigFileDialog from '@/components/business/uploadBigFileDialog/uploadBigFileDialog.vue';
export default {
	props: {
		materialType: {
			type: [String, Number],
			default: '',
		},
		refreshKey: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			checkAll: false,
			selectionList: [],
			tableData: [],
			total: 0,
			pageInfo: {
				page_index: 1,
				page_size: 10,
			},
			params: {},
			orderByField: 'addTime',
			orderBySort: 'desc',
			indeterminate: false,
			downloadLoading: false,
			hoverRow: {},
			options: {
				selectable: true,
				border: false,
			},
			loading: false,
		};
	},
	computed: {
		isVideoMaterial() {
			return this.materialType == 1;
		},
		columns() {
			return getColumns(this);
		},
	},
	watch: {
		selectionList: {
			handler(val) {
				this.indeterminate = val.length ? val.length !== this.tableData.length : false;
				this.checkAll = val && val.length && val.length === this.tableData.length;
			},
			deep: true,
		},
	},
	components: {
		ruleSettings,
		UploadBigFileDialog,
		TagDialog,
	},
	methods: {
		openSettings: debounce(function () {
			this.$refs.ruleSettings.show();
		}, 300),
		refresh() {
			this.$emit('updateLeftSize');
			this.getList();
		},
		async getList(params) {
			try {
				this.loading = true;
				if (params) {
					this.params = params;
					this.pageInfo = {
						page_index: 1,
						page_size: 10,
					};
				}
				const requestParams = {
					pageIndex: this.pageInfo.page_index,
					pageSize: this.pageInfo.page_size,
					...this.params,
					orderByField: this.orderByField,
					orderBySort: this.orderBySort,
				};
				const { data } = await materialLibraryList(requestParams);
				this.tableData = data.list.map(item => ({
					...item,
					operations: { tagDialog: this.handleEditTag },
					operation: this.getButtons(item),
					visible: false,
				}));
				this.total = data.page.itemTotal;
				this.selectionList = [];
				this.indeterminate = false;
			} finally {
				this.loading = false;
			}
		},
		handleEditTag(row) {
			this.$refs.tagDialog.show('编辑标签', [row]);
		},
		selectAll(val) {
			this.selectionList = val ? [...this.tableData] : [];
			this.$refs.table.toggleSelection(this.tableData, val);
		},
		handleUpload() {
			this.$refs.uploadVideo.show();
		},
		handleAddTag() {
			if (!this.selectionList.length) {
				return;
			}
			this.$refs.tagDialog.show('批量添加标签', this.selectionList);
		},
		async handleDown(row) {
			const params = { ids: [row.id], needFeedbackFlag: false };
			let { data } = await batchDownload(params);
			const { downloadUrl: link, errorMsg, success } = data[0];
			if (!success) {
				return this.$message.error(errorMsg);
			}
			var filename = link.split('/').pop().split('?')[0];
			this.download(link, filename);
		},
		download(url, filename) {
			const a = document.createElement('a');
			a.href = url;
			a.download = filename;
			a.rel = 'noopener noreferrer';
			a.click();
			a.remove();
		},
		gePartnerList({ page_index, page_size }) {
			this.pageInfo.page_index = page_index;
			this.pageInfo.page_size = page_size;
			this.getList();
		},
		sortChange({ prop, order }) {
			let orderBy = order ? (order === 'ascending' ? 'asc' : 'desc') : '';
			this.orderByField = prop;
			this.orderBySort = orderBy;
			this.getList();
		},
		cellMouseEnter(row) {
			this.tableData.map(val => {
				if (+val.id === +row.id) {
					val.visible = true;
				}
			});
		},
		cellMouseLeave() {
			this.tableData.map(val => {
				val.visible = false;
			});
			this.hoverRow = {};
		},
		handleSelectionChange(val) {
			this.selectionList = val;
		},
		handleDel(row) {
			const isBatchDel = !row;
			if (isBatchDel && !this.selectionList.length) {
				return;
			}
			this.$modal({
				title: '提示',
				contentTitle: '是否确认删除？素材删除后无法恢复',
				size: 'small',
			}).then(async res => {
				if (res.key == 'confirm') {
					const params = isBatchDel ? { ids: this.selectionList.map(item => item.id) } : { ids: [row.id] };
					await batchDeleteMaterial(params);
					this.$message.success('素材删除成功');
					this.pageInfo.page_index = 1;
					this.$emit('updateLeftSize');
					this.getList();
					res.done();
				} else {
					res.done();
				}
			});
		},
		getButtons(item) {
			let arr = [];
			arr.push(
				{
					label: '下载',
					type: 'text',
					classtype: 2,
					isShow: this.$auth.hasPermi('download:local-material'),
					click: () => {
						this.handleDown(item);
					},
				},
				{
					label: '删除',
					type: 'text',
					classtype: 2,
					isShow: this.$auth.hasPermi('delete:local-material'),
					click: () => {
						this.handleDel(item);
					},
				},
			);
			return arr.filter(val => val.isShow);
		},
	},
};
</script>
